import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { FormSubmission } from '@uplift/types';


export type FormSubmissionIdByPatientAndFormInput = {
  formId: string;
  patientId: string;
};


export const latestSubmittedFormSubmissionByPatientAndForm = (params: FormSubmissionIdByPatientAndFormInput) => restClient.request<{
  data: FormSubmission;
}>('/api/v1/form/latest-submitted-submission-by-form-and-patient', {
  method: 'GET',
  params: snakecaseKeys(params),
});
